(() => {
  if (customElements.get("product-media-slideshow")) {
    return;
  }

  class ProductMediaSlideshow extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector("[data-slider]");
      this.thumbsElement = this.querySelector("[data-thumbs]");

      this.thumbs = new Swiper(this.thumbsElement, {
        slidesPerView: 4,
        spaceBetween: 10,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]')
        },
        watchSlidesProgress: true,
        autoHeight: true,
        direction: "horizontal",
        breakpoints: {
          1201: {
            slidesPerView: 5,
          }
        },
        on: {
          click: (swiper) => {
            swiper.slideTo(swiper.clickedIndex);
          }
        }
      });

      this.swiper = new Swiper(this.sliderElement, {
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 8,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]')
        },
        thumbs: {
          swiper: this.thumbs
        },
        breakpoints: {
          768: {
          }
        }
      });


      const lightbox = new PhotoSwipeLightbox({
        gallery: this,
        children: "a[data-pswp-image]",
        pswpModule: PhotoSwipe,
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
        preloadFirstSlide: true,
      });

      lightbox.init();
    }

    setActive(id) {
      const slideElement = this.swiper.slides.find((s) => s.id === id);
      const slideIndex = this.swiper.slides.indexOf(slideElement);
      this.swiper.slideTo(slideIndex)

      if (window.innerWidth > 767 && slideElement) {
        slideElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  customElements.define("product-media-slideshow", ProductMediaSlideshow);
})();
